module.exports = __webpack_public_path__ + "static/JosefinSans-Bold-e314da2c0c4113fe575fa8a22cec8394.ttf";